var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3.333 22.667a32.2 32.2 0 0 1 0-13.334A2.67 2.67 0 0 1 5.2 7.467a66.1 66.1 0 0 1 21.6 0 2.67 2.67 0 0 1 1.867 1.866 32.2 32.2 0 0 1 0 13.334 2.67 2.67 0 0 1-1.867 1.866 66 66 0 0 1-21.6 0 2.67 2.67 0 0 1-1.867-1.866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13.333 20 20 16l-6.667-4z"
  })));
};
export default SvgYoutube;